import { render, staticRenderFns } from "./sales-statistics.vue?vue&type=template&id=4e619e35&scoped=true"
import script from "./sales-statistics.vue?vue&type=script&lang=js"
export * from "./sales-statistics.vue?vue&type=script&lang=js"
import style0 from "./sales-statistics.vue?vue&type=style&index=0&id=4e619e35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e619e35",
  null
  
)

export default component.exports